// Auto-generated by scripts/parse-test-results.ts
// Do not edit manually - run "bun run test:results" to regenerate
import type { FeatureTestStatus, ScenarioTestResult } from '../types/gherkin';

interface RawFeatureTestStatus {
  featureId: string;
  totalScenarios: number;
  passed: number;
  failed: number;
  skipped: number;
  lastRun?: string;
  scenarios?: ScenarioTestResult[];
}

const rawResults: RawFeatureTestStatus[] = [
  {
    "featureId": "us-13",
    "totalScenarios": 10,
    "passed": 7,
    "failed": 0,
    "skipped": 3,
    "lastRun": "2026-01-26T17:31:35.878Z",
    "scenarios": [
      {
        "name": "Accéder au formulaire de relai d'événement",
        "status": "passed"
      },
      {
        "name": "Vérifier les champs obligatoires du formulaire",
        "status": "passed"
      },
      {
        "name": "Vérifier la présence du bouton de relai",
        "status": "passed"
      },
      {
        "name": "Pouvoir annuler le relai d'événement",
        "status": "passed"
      },
      {
        "name": "Détecter un événement similaire déjà relayé",
        "status": "passed"
      },
      {
        "name": "Importer un événement depuis une source externe",
        "status": "passed"
      },
      {
        "name": "Pas d'alerte doublon lors d'un import externe",
        "status": "passed"
      },
      {
        "name": "Modifier un événement",
        "status": "skipped"
      },
      {
        "name": "Supprimer un événement",
        "status": "skipped"
      },
      {
        "name": "Retirer une organisation (personne ou structure)",
        "status": "skipped"
      }
    ]
  },
  {
    "featureId": "us-3",
    "totalScenarios": 3,
    "passed": 3,
    "failed": 0,
    "skipped": 0,
    "lastRun": "2026-01-26T17:31:35.878Z",
    "scenarios": [
      {
        "name": "Accéder aux détails d'un événement terminé",
        "status": "passed"
      },
      {
        "name": "Voir la description de l'événement",
        "status": "passed"
      },
      {
        "name": "Voir la liste des participants",
        "status": "passed"
      }
    ]
  },
  {
    "featureId": "us-5",
    "totalScenarios": 5,
    "passed": 0,
    "failed": 0,
    "skipped": 5,
    "lastRun": "2026-01-26T17:31:35.878Z",
    "scenarios": [
      {
        "name": "Voir les commentaires existants",
        "status": "skipped"
      },
      {
        "name": "Ajouter un commentaire",
        "status": "skipped"
      },
      {
        "name": "Modifier un commentaire",
        "status": "skipped"
      },
      {
        "name": "Supprimer un commentaire",
        "status": "skipped"
      },
      {
        "name": "Enregistrer les interactions avec des individus (Date/Heure/Lieu)",
        "status": "skipped"
      }
    ]
  },
  {
    "featureId": "us-7",
    "totalScenarios": 6,
    "passed": 2,
    "failed": 0,
    "skipped": 4,
    "lastRun": "2026-01-26T17:31:35.878Z",
    "scenarios": [
      {
        "name": "Consulter un événement avant inscription",
        "status": "passed"
      },
      {
        "name": "S'inscrire à un événement",
        "status": "skipped"
      },
      {
        "name": "Se désinscrire d'un événement",
        "status": "skipped"
      },
      {
        "name": "Rechercher un événement existant",
        "status": "passed"
      },
      {
        "name": "Vérifier les données de l'écran",
        "status": "skipped"
      },
      {
        "name": "Rechercher dans une base existante (Mobilizon)",
        "status": "skipped"
      }
    ]
  },
  {
    "featureId": "us-8",
    "totalScenarios": 8,
    "passed": 0,
    "failed": 0,
    "skipped": 8,
    "lastRun": "2026-01-26T17:31:35.879Z",
    "scenarios": [
      {
        "name": "Consulter un macro-événement",
        "status": "skipped"
      },
      {
        "name": "Voir les événements rattachés",
        "status": "skipped"
      },
      {
        "name": "Rattacher un événement existant",
        "status": "skipped"
      },
      {
        "name": "Voir la consolidation des participants",
        "status": "skipped"
      },
      {
        "name": "Créer un macro-événement",
        "status": "skipped"
      },
      {
        "name": "Voir la consolidation des commentaires/liens/ressources",
        "status": "skipped"
      },
      {
        "name": "Rattacher à une thématique particulière",
        "status": "skipped"
      },
      {
        "name": "Gérer un événement répété sur plusieurs périodes",
        "status": "skipped"
      }
    ]
  },
  {
    "featureId": "us-16",
    "totalScenarios": 4,
    "passed": 4,
    "failed": 0,
    "skipped": 0,
    "lastRun": "2026-01-26T17:31:35.879Z",
    "scenarios": [
      {
        "name": "Accéder aux points de rencontre",
        "status": "passed"
      },
      {
        "name": "Voir le bouton pour proposer un point de rencontre",
        "status": "passed"
      },
      {
        "name": "Ouvrir le formulaire de proposition",
        "status": "passed"
      },
      {
        "name": "Définir l'heure de rencontre",
        "status": "passed"
      }
    ]
  },
  {
    "featureId": "us-17",
    "totalScenarios": 5,
    "passed": 0,
    "failed": 0,
    "skipped": 5,
    "lastRun": "2026-01-26T17:31:35.879Z",
    "scenarios": [
      {
        "name": "Partager un événement auquel je participe",
        "status": "skipped"
      },
      {
        "name": "Informer les utilisateurs à proximité",
        "status": "skipped"
      },
      {
        "name": "Informer les utilisateurs par thématique",
        "status": "skipped"
      },
      {
        "name": "Informer mes abonnés",
        "status": "skipped"
      },
      {
        "name": "Combiner les options de notification",
        "status": "skipped"
      }
    ]
  },
  {
    "featureId": "us-18",
    "totalScenarios": 4,
    "passed": 1,
    "failed": 0,
    "skipped": 3,
    "lastRun": "2026-01-26T17:31:35.879Z",
    "scenarios": [
      {
        "name": "Configurer les notifications de nouveaux participants",
        "status": "passed"
      },
      {
        "name": "Activer les notifications pour un événement",
        "status": "skipped"
      },
      {
        "name": "Filtrer les notifications par réseau",
        "status": "skipped"
      },
      {
        "name": "Voir les nouveaux participants sur l'accueil",
        "status": "skipped"
      }
    ]
  },
  {
    "featureId": "us-19",
    "totalScenarios": 5,
    "passed": 3,
    "failed": 0,
    "skipped": 2,
    "lastRun": "2026-01-26T17:31:35.879Z",
    "scenarios": [
      {
        "name": "Voir les événements à venir sur l'accueil",
        "status": "passed"
      },
      {
        "name": "Voir le récapitulatif par période",
        "status": "skipped"
      },
      {
        "name": "Voir les événements proches géographiquement",
        "status": "skipped"
      },
      {
        "name": "Voir mes inscriptions",
        "status": "passed"
      },
      {
        "name": "Vérifier les données de l'accueil",
        "status": "passed"
      }
    ]
  },
  {
    "featureId": "us-10",
    "totalScenarios": 6,
    "passed": 5,
    "failed": 0,
    "skipped": 1,
    "lastRun": "2026-01-26T17:31:35.879Z",
    "scenarios": [
      {
        "name": "Accéder au profil d'un participant",
        "status": "passed"
      },
      {
        "name": "Voir les événements du participant",
        "status": "passed"
      },
      {
        "name": "Voir la localisation des événements",
        "status": "passed"
      },
      {
        "name": "Voir le formulaire de contact",
        "status": "passed"
      },
      {
        "name": "Vérifier les informations du profil",
        "status": "skipped"
      },
      {
        "name": "Voir les détails du profil utilisateur",
        "status": "passed"
      }
    ]
  },
  {
    "featureId": "us-12",
    "totalScenarios": 7,
    "passed": 3,
    "failed": 0,
    "skipped": 4,
    "lastRun": "2026-01-26T17:31:35.879Z",
    "scenarios": [
      {
        "name": "Accéder à la liste des événements depuis le profil",
        "status": "skipped"
      },
      {
        "name": "Accéder à la liste des événements depuis découvrir",
        "status": "passed"
      },
      {
        "name": "Filtrer par date",
        "status": "skipped"
      },
      {
        "name": "Filtrer par personne",
        "status": "passed"
      },
      {
        "name": "Vérifier les données de l'écran événements",
        "status": "passed"
      },
      {
        "name": "Vérifier les données de l'écran profil",
        "status": "skipped"
      },
      {
        "name": "Voir la vue carte des événements",
        "status": "skipped"
      }
    ]
  },
  {
    "featureId": "us-15",
    "totalScenarios": 5,
    "passed": 3,
    "failed": 0,
    "skipped": 2,
    "lastRun": "2026-01-26T17:31:35.879Z",
    "scenarios": [
      {
        "name": "Accéder à la liste des inscrits d'un événement",
        "status": "passed"
      },
      {
        "name": "Accéder à la liste des inscrits d'un atelier",
        "status": "skipped"
      },
      {
        "name": "Voir la liste des participants d'un événement",
        "status": "passed"
      },
      {
        "name": "Voir la liste des participants d'un atelier",
        "status": "skipped"
      },
      {
        "name": "Cliquer sur un inscrit pour voir son profil",
        "status": "passed"
      }
    ]
  },
  {
    "featureId": "us-20",
    "totalScenarios": 6,
    "passed": 5,
    "failed": 0,
    "skipped": 1,
    "lastRun": "2026-01-26T17:31:35.879Z",
    "scenarios": [
      {
        "name": "Accéder à mon profil",
        "status": "passed"
      },
      {
        "name": "Voir mon réseau",
        "status": "passed"
      },
      {
        "name": "Voir un profil de mon réseau",
        "status": "passed"
      },
      {
        "name": "Consulter un événement depuis un profil",
        "status": "passed"
      },
      {
        "name": "Vérifier les données du profil",
        "status": "passed"
      },
      {
        "name": "Voir les profils publiques",
        "status": "skipped"
      }
    ]
  },
  {
    "featureId": "us-21",
    "totalScenarios": 5,
    "passed": 2,
    "failed": 0,
    "skipped": 3,
    "lastRun": "2026-01-26T17:31:35.879Z",
    "scenarios": [
      {
        "name": "Accéder aux paramètres de profil",
        "status": "passed"
      },
      {
        "name": "Configurer la visibilité du profil",
        "status": "passed"
      },
      {
        "name": "Rendre le profil public",
        "status": "skipped"
      },
      {
        "name": "Vérifier les données des paramètres",
        "status": "skipped"
      },
      {
        "name": "Vérifier les données du profil",
        "status": "skipped"
      }
    ]
  },
  {
    "featureId": "us-22",
    "totalScenarios": 5,
    "passed": 5,
    "failed": 0,
    "skipped": 0,
    "lastRun": "2026-01-26T17:31:35.879Z",
    "scenarios": [
      {
        "name": "Accéder au partage de profil",
        "status": "passed"
      },
      {
        "name": "Naviguer vers le partage de profil",
        "status": "passed"
      },
      {
        "name": "Voir le QR code de parrainage",
        "status": "passed"
      },
      {
        "name": "Voir le lien de parrainage",
        "status": "passed"
      },
      {
        "name": "Voir les statistiques de parrainage",
        "status": "passed"
      }
    ]
  },
  {
    "featureId": "us-23",
    "totalScenarios": 5,
    "passed": 5,
    "failed": 0,
    "skipped": 0,
    "lastRun": "2026-01-26T17:31:35.879Z",
    "scenarios": [
      {
        "name": "Accéder au partage depuis le profil",
        "status": "passed"
      },
      {
        "name": "Voir le QR code",
        "status": "passed"
      },
      {
        "name": "Voir le lien de partage",
        "status": "passed"
      },
      {
        "name": "Accéder à l'écran de partage dédié",
        "status": "passed"
      },
      {
        "name": "Vérifier les données du profil",
        "status": "passed"
      }
    ]
  },
  {
    "featureId": "us-24",
    "totalScenarios": 3,
    "passed": 2,
    "failed": 0,
    "skipped": 1,
    "lastRun": "2026-01-26T17:31:35.879Z",
    "scenarios": [
      {
        "name": "Accéder aux paramètres de notification",
        "status": "passed"
      },
      {
        "name": "Configurer les notifications de contacts",
        "status": "passed"
      },
      {
        "name": "Voir les activités de mes contacts sur l'accueil",
        "status": "skipped"
      }
    ]
  },
  {
    "featureId": "us-25",
    "totalScenarios": 3,
    "passed": 1,
    "failed": 0,
    "skipped": 2,
    "lastRun": "2026-01-26T17:31:35.879Z",
    "scenarios": [
      {
        "name": "Accéder aux paramètres de notification",
        "status": "passed"
      },
      {
        "name": "Configurer le rayon de notification",
        "status": "skipped"
      },
      {
        "name": "Configurer les thématiques d'intérêt",
        "status": "skipped"
      }
    ]
  },
  {
    "featureId": "us-26",
    "totalScenarios": 4,
    "passed": 3,
    "failed": 0,
    "skipped": 1,
    "lastRun": "2026-01-26T17:31:35.879Z",
    "scenarios": [
      {
        "name": "Accéder au formulaire de relai d'événement",
        "status": "passed"
      },
      {
        "name": "Définir le rayon d'intérêt",
        "status": "skipped"
      },
      {
        "name": "Choisir une thématique",
        "status": "passed"
      },
      {
        "name": "Vérifier les champs obligatoires",
        "status": "passed"
      }
    ]
  },
  {
    "featureId": "us-9",
    "totalScenarios": 5,
    "passed": 4,
    "failed": 0,
    "skipped": 1,
    "lastRun": "2026-01-26T17:31:35.879Z",
    "scenarios": [
      {
        "name": "Accéder au profil pour voir la photo",
        "status": "passed"
      },
      {
        "name": "Naviguer vers le profil depuis la liste des participants",
        "status": "passed"
      },
      {
        "name": "Consulter la liste des inscrits à un atelier",
        "status": "passed"
      },
      {
        "name": "Vérifier les champs de données du profil",
        "status": "passed"
      },
      {
        "name": "Ajouter une photo personnelle sur une fiche existante",
        "status": "skipped"
      }
    ]
  },
  {
    "featureId": "us-1",
    "totalScenarios": 5,
    "passed": 0,
    "failed": 0,
    "skipped": 5,
    "lastRun": "2026-01-26T17:31:35.879Z",
    "scenarios": [
      {
        "name": "Accéder aux détails d'un événement terminé",
        "status": "skipped"
      },
      {
        "name": "Consulter la liste des participants d'un atelier",
        "status": "skipped"
      },
      {
        "name": "Consulter les ressources d'un atelier",
        "status": "skipped"
      },
      {
        "name": "Consulter le programme détaillé par journée/heure",
        "status": "skipped"
      },
      {
        "name": "Accéder à la zone de partage collective",
        "status": "skipped"
      }
    ]
  },
  {
    "featureId": "us-11",
    "totalScenarios": 3,
    "passed": 0,
    "failed": 0,
    "skipped": 3,
    "lastRun": "2026-01-26T17:31:35.879Z",
    "scenarios": [
      {
        "name": "Accéder au bilan consolidé",
        "status": "skipped"
      },
      {
        "name": "Voir les commentaires regroupés par atelier",
        "status": "skipped"
      },
      {
        "name": "Voir la synthèse globale",
        "status": "skipped"
      }
    ]
  },
  {
    "featureId": "us-14",
    "totalScenarios": 7,
    "passed": 0,
    "failed": 0,
    "skipped": 7,
    "lastRun": "2026-01-26T17:31:35.879Z",
    "scenarios": [
      {
        "name": "Accéder à la création d'atelier",
        "status": "skipped"
      },
      {
        "name": "Vérifier les champs obligatoires pour créer un atelier",
        "status": "skipped"
      },
      {
        "name": "Créer un atelier",
        "status": "skipped"
      },
      {
        "name": "Modifier un atelier existant",
        "status": "skipped"
      },
      {
        "name": "Supprimer un atelier",
        "status": "skipped"
      },
      {
        "name": "Sélectionner mon événement parent",
        "status": "skipped"
      },
      {
        "name": "Définir les horaires de fin de l'atelier",
        "status": "skipped"
      }
    ]
  },
  {
    "featureId": "us-2",
    "totalScenarios": 5,
    "passed": 0,
    "failed": 0,
    "skipped": 5,
    "lastRun": "2026-01-26T17:31:35.879Z",
    "scenarios": [
      {
        "name": "Accéder à la zone de notes personnelles",
        "status": "skipped"
      },
      {
        "name": "Accéder à la zone de partage publique",
        "status": "skipped"
      },
      {
        "name": "Ajouter une note personnelle",
        "status": "skipped"
      },
      {
        "name": "Ajouter un lien/ressource",
        "status": "skipped"
      },
      {
        "name": "Consulter le programme détaillé des ateliers par journée/heure",
        "status": "skipped"
      }
    ]
  },
  {
    "featureId": "us-4",
    "totalScenarios": 5,
    "passed": 0,
    "failed": 0,
    "skipped": 5,
    "lastRun": "2026-01-26T17:31:35.879Z",
    "scenarios": [
      {
        "name": "Voir les commentaires existants d'un atelier",
        "status": "skipped"
      },
      {
        "name": "Ajouter un commentaire à un atelier",
        "status": "skipped"
      },
      {
        "name": "Modifier un commentaire existant",
        "status": "skipped"
      },
      {
        "name": "Supprimer un commentaire",
        "status": "skipped"
      },
      {
        "name": "Accéder à l'icône ajouter un commentaire",
        "status": "skipped"
      }
    ]
  },
  {
    "featureId": "us-6",
    "totalScenarios": 4,
    "passed": 0,
    "failed": 0,
    "skipped": 4,
    "lastRun": "2026-01-26T17:31:35.879Z",
    "scenarios": [
      {
        "name": "Voir les ateliers d'un événement",
        "status": "skipped"
      },
      {
        "name": "Voir les personnes pré-inscrites à un atelier",
        "status": "skipped"
      },
      {
        "name": "S'inscrire à un atelier",
        "status": "skipped"
      },
      {
        "name": "Se désinscrire d'un atelier",
        "status": "skipped"
      }
    ]
  }
];

export const testResults: Map<string, FeatureTestStatus> = new Map(
  rawResults.map(r => [r.featureId, { ...r, lastRun: r.lastRun ? new Date(r.lastRun) : undefined }])
);

export function getTestStatus(featureId: string): FeatureTestStatus | undefined {
  return testResults.get(featureId);
}

export function getScenarioResults(featureId: string): ScenarioTestResult[] {
  return testResults.get(featureId)?.scenarios ?? [];
}

export function getAllTestResults(): FeatureTestStatus[] {
  return Array.from(testResults.values());
}

export function getTestSummary() {
  const results = getAllTestResults();
  const firstResult = results[0];
  return {
    totalFeatures: results.length,
    totalScenarios: results.reduce((acc, r) => acc + r.totalScenarios, 0),
    passed: results.reduce((acc, r) => acc + r.passed, 0),
    failed: results.reduce((acc, r) => acc + r.failed, 0),
    skipped: results.reduce((acc, r) => acc + r.skipped, 0),
    lastRun: firstResult?.lastRun,
  };
}
